const shouldForwardProp = (props: string[] = []) => ({
  shouldForwardProp: shouldForwardPropFn(props),
})

const shouldForwardPropFn = (props: string[] = []) => (prop: string): boolean => ![
  ...props,
].includes(prop as string)

export {
  shouldForwardPropFn,
  shouldForwardProp,
}
